<template>
    <div>
        <keep-alive include="CabinetMap">
            <router-view/>
        </keep-alive>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
